export const misc = {
    mutations: {
        RESET_FROM_INITIAL_STATE(state, payload) {
            this.$vue.set(this.state[payload.args.module], payload.args.object, payload.initialState[payload.args.module][payload.args.object])
        }
    },
    actions: {
        resetFromInitialState({ commit }, args) {
            return this.$storage.getItem('initialState').then(initialState => {
                commit('RESET_FROM_INITIAL_STATE', {
                    args,
                    initialState
                })
            })
        }
    }
}
